import { render, staticRenderFns } from "./question.vue?vue&type=template&id=7ac37eea&lang=pug"
import script from "./question.vue?vue&type=script&setup=true&lang=js"
export * from "./question.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports